
import React from 'react';
import { CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import AuthLogo from './AuthLogo';

interface AuthHeaderProps {
  title: string;
  description: string;
}

const AuthHeader = ({ title, description }: AuthHeaderProps) => {
  return (
    <CardHeader className="space-y-1">
      <AuthLogo />
      <CardTitle className="text-2xl font-bold tracking-tight text-center">
        {title}
      </CardTitle>
      <CardDescription className="text-center">
        {description}
      </CardDescription>
    </CardHeader>
  );
};

export default AuthHeader;
